export default __webpack_public_path__ + "static/media/PrazskyHrad2_sm.6d7415bb.jpg";